import React from 'react';
import styled from 'styled-components';

import UserReviewLeftComponent from '../UserReviewLeftComponent/UserReviewLeftComponent';
import UserReviewRightComponent from '../UserReviewRightComponent/UserReviewRightComponent';

const UserReview = () => (
  <UserReviewWrapDiv>
    <UserReviewOuterWrapDiv>
      <UserReviewLeftComponent></UserReviewLeftComponent>
      <UserReviewRightComponent></UserReviewRightComponent>
    </UserReviewOuterWrapDiv>
  </UserReviewWrapDiv>
);

export default UserReview;

const UserReviewWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  width:100%;
  justify-content: space-between;
  padding:${props.theme.spacing.large};

`,
);

const UserReviewOuterWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  border: ${props.theme.misc.border.base} solid ${props.theme.colors.ash.medium};
  width:100%;
  justify-content: space-between;
  padding:${props.theme.spacing.large};
  border-radius:${props.theme.misc.borderRadius.xlarge};


`,
);
